module.exports = __webpack_public_path__ + "img/learn-4.1c9ab28f.png";